import { render, staticRenderFns } from "./addItemToCart.vue?vue&type=template&id=45a80033&"
import script from "./addItemToCart.vue?vue&type=script&lang=js&"
export * from "./addItemToCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports